//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useTheme } from 'styled-components';

import { IButtonStateStyles } from '@components/atoms/button/buttonStyles';

// TODO: PD-257587 - remove this hook
export const useVibeButtonStyles = (): IButtonStateStyles => {
  const theme = useTheme();
  return {
    fixed: {
      fontWeight: 'bold',
      borderShape: 'pill',
      borderThickness: 'thick',
    },
    standard: {
      color: theme.colors.white,
      backgroundColor: 'transparent',
      borderColor: theme.colors.white,
    },
    hover: {
      color: '#3D4CBF',
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.white,
    },
    active: {
      color: '#242D72',
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.white,
    },
    disabled: {
      color: theme.colors.gray4,
      backgroundColor: theme.colors.gray0,
      borderColor: theme.colors.gray0,
    },
  };
};
